import { takeLatest, call, put } from 'redux-saga/effects';
import historyActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: { LOAD_HISTORY_REQUEST },
  Creators: { loadHistorySuccess, loadHistoryFailure },
} = historyActions;

const {
  Creators: { setError },
} = errorActions;

function* loadHistory({ payload }) {
  const { start, end, used, limit } = payload;
  try {
    const { data } = yield call(
      dxApi.get,
      `/api/profile/checkins-nv2?startDate=${start}&endDate=${end}&limit=${used || limit}`
    );
    yield put(loadHistorySuccess(data.data));
  } catch (error) {
    yield put(loadHistoryFailure(error));
    yield put(setError('Load history error.'));
  }
}

export function* historySaga() {
  yield takeLatest(LOAD_HISTORY_REQUEST, loadHistory);
}
